import { render } from "./OrgFeesInvoicePage.vue?vue&type=template&id=0639e1db"
import script from "./OrgFeesInvoicePage.vue?vue&type=script&lang=js"
export * from "./OrgFeesInvoicePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__